import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Observable, catchError, of, tap, throwError } from "rxjs";
import { Injectable } from "@angular/core";
import { ToasterService } from "../global/toast-service";
import * as NavigationActions from '../../../store/common/navigation/navigation.actions';
import { Store } from "@ngrx/store";

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {

    constructor(private store: Store, private toastService: ToasterService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap(evt => {
                if (evt instanceof HttpResponse) { }
            }),
            catchError(err => {
                switch (err.status) {
                    case 0:
                        this.toastService.showError('No response.' as string);
                        break
                }

                if (err.error.Errors) {
                    this.toastService.showErrors(err.error.Errors as string[]);
                }

                this.store.dispatch(NavigationActions.hideSpinner({}));

                return of(err);
            }));
    }
}